export const COOKIE_KEYS = {
    USER: 'user',
    BRANCH_IDS: 'branch_ids',
};